/**
 * TRIL-669. An absent score means "not scored yet" — either the analyzer has not
 * answered (~3-12s after publish) or it never did. Those are the SAME state and
 * deliberately render identically: a spinner would promise a resolution that an
 * analyzer outage never delivers.
 *
 * Absence is `null`/`undefined`/non-finite. It is NOT `0` — zero is a real score
 * the server genuinely broadcasts.
 */
export const UNSCORED_PLACEHOLDER = '—';

export function formatScore(score: number | null | undefined): string {
  return typeof score === 'number' && Number.isFinite(score)
    ? score.toFixed(1)
    : UNSCORED_PLACEHOLDER;
}
